import React from 'react';
import moment, { Moment } from 'moment';
import {
  DatePicker,
  TableFilters,
  BelongsToFilterSelects,
  InputContainer,
  TableFilterSelect,
} from '../../design-system';
import { extendContainerValidator, showToRoles } from '../../utils';
import { FiltersSetStatesProp, User } from '../../types';
import {
  containerConditionOptions,
  containerStatues,
  containerTypes,
  INPUT_ERRORS,
} from '../../const';
import { i18n } from '../../i18n';

interface Props {
  user: User;
  number?: string;
  type?: string;
  condition?: string;
  status?: any;
  startDate?: Moment;
  endDate?: Moment;
  isSubmitClicked?: boolean;
  setStates: FiltersSetStatesProp;
}

export const Filters: React.FC<Props> = ({
  user,
  number = '',
  type,
  condition,
  status,
  startDate,
  endDate,
  isSubmitClicked,
  setStates,
}: Props) => {
  return (
    <TableFilters id={'reports-filters'}>
      <BelongsToFilterSelects
        handleChange={(obj) => {
          setStates('force', obj);
        }}
        isYardRequired={showToRoles(
          ['SUPER_ADMIN', 'YARD_COMPANY_ADMIN', 'YARD_COMPANY_EMPLOYEE', 'YARD_COMPANY_VIEWER'],
          user,
        )}
        isClientRequired
        isSubmitClicked={isSubmitClicked}
      />
      <InputContainer
        label={i18n.t('label.containerNumber')}
        data-size={'medium'}
        defaultValue={number}
        onChange={(e) => {
          const value = e.target.value.toUpperCase();
          setStates('force', { number: value });
        }}
        helperText={
          number.length !== 0 && number.length < 3
            ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_MIN
            : !extendContainerValidator(number)
            ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_SHORT
            : ''
        }
        alwaysShowHelperText
      />
      <TableFilterSelect
        label={i18n.t('label.type')}
        options={containerTypes}
        value={type}
        onChange={(e) => setStates('force', { type: e.target.value })}
      />
      <TableFilterSelect
        label={i18n.t('label.condition')}
        options={containerConditionOptions}
        value={condition}
        onChange={(e) => setStates('force', { condition: e.target.value })}
      />
      <TableFilterSelect
        label={i18n.t('label.status')}
        options={containerStatues(user.canTrade)}
        value={status}
        onChange={(e) => {
          setStates('force', {
            status: e.target.value,
            startDate: null,
            endDate: null,
          });
        }}
      />
      <DatePicker
        label={i18n.t('label.from')}
        data-size={'medium'}
        defaultValue={startDate}
        onChange={(e) => setStates('force', { startDate: e })}
        maxDate={endDate ? moment(endDate) : moment()}
      />
      <DatePicker
        label={i18n.t('label.to')}
        data-size={'medium'}
        defaultValue={endDate}
        onChange={(e) => setStates('force', { endDate: e })}
        minDate={startDate ? moment(startDate) : null}
        maxDate={moment()}
      />
    </TableFilters>
  );
};
